import { useModal } from "@/components/product/table/modal/context";
import api from "@/config/api";
import { Params } from "@/types/utils";
import { log } from "@/utils/logger";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

const useTransfer = () => {
    const onClose = useModal(state => state.onClose);
    const setLoading = useModal(state => state.setLoading);

    const queryClient = useQueryClient();
    const { oid, bid } = useParams<Params>();

    const onTransfer = async (pid: string, receiver: string) => {
        try {
            setLoading(true);
            await api.patch(`/organizations/${oid}/brands/${bid}/products/${pid}/transfer`, {
                data: { receiver },
            });

            queryClient.invalidateQueries({ queryKey: ["products"], exact: false });
            log.success("Product has been successfully transferred.");
        } catch (e) {
            log.error(e, "useTransfer.onTransfer");
        } finally {
            setLoading(false), onClose();
        }
    };

    return onTransfer;
};

export { useTransfer };
